import React from 'react';

import Button from 'components/Button';
import Modal, { ModalProps } from 'components/Modal';
import { Typography } from '@material-ui/core';
import useStyles from 'components/Crud/styles';
import { capitalise } from 'utils';

interface DeleteConfirmationModalProps extends ModalProps {
  onDelete: () => void;
  onCancel: () => void;
  deletionSubject?: string;
}

export default function DeleteConfirmationModal({
  onDelete,
  onCancel,
  testId,
  children,
  deletionSubject = 'item',
  ...props
}: DeleteConfirmationModalProps) {
  const classes = useStyles();

  return (
    <Modal
      testId={testId}
      modalActions={
        <>
          <Button
            color="secondary"
            size="medium"
            onClick={onCancel}
            data-testid={`${testId}CancelButton`}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="medium"
            onClick={onDelete}
            data-testid={`${testId}DeleteButton`}
            isErrorButton
          >
            Delete
          </Button>
        </>
      }
      {...props}
    >
      <Typography
        data-testid={`${testId}Text`}
        className={classes.deletionModalText}
      >
        {`Are you sure you want to delete the selected ${capitalise(
          deletionSubject
        )}? It will no longer be available.`}
      </Typography>

      {children}
    </Modal>
  );
}
